import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Calendar, ArrowRight, BookOpen } from 'lucide-react';

const Blog = () => {
  const articulos = [
    {
      slug: 'subvenciones-placas-solares-espana-2026',
      titulo: 'Subvenciones para Placas Solares en España en 2026',
      extracto: 'Guía completa sobre todas las ayudas, subvenciones y deducciones fiscales disponibles para instalar placas solares en España.',
      fecha: '10 de marzo, 2026',
      imagen: 'https://images.unsplash.com/photo-1559302504-64aae6ca6b6d',
      categoria: 'Ayudas y Subvenciones'
    },
    {
      slug: 'cuanto-cuesta-instalar-placas-solares-madrid',
      titulo: 'Cuánto Cuesta Instalar Placas Solares en una Vivienda en Madrid',
      extracto: 'Análisis detallado de los costes de instalación de paneles solares en Madrid, factores que influyen en el precio y retorno de inversión.',
      fecha: '8 de marzo, 2026',
      imagen: 'https://images.unsplash.com/photo-1509391366360-2e959784a276',
      categoria: 'Precios y Presupuestos'
    },
    {
      slug: 'cuantas-placas-solares-necesita-una-casa',
      titulo: 'Cuántas Placas Solares Necesita una Casa',
      extracto: 'Aprende a calcular el número de paneles solares que necesitas según tu consumo energético, superficie disponible y orientación del tejado.',
      fecha: '5 de marzo, 2026',
      imagen: 'https://images.pexels.com/photos/30440447/pexels-photo-30440447.jpeg',
      categoria: 'Guías Prácticas'
    }
  ];

  return (
    <>
      <Helmet>
        <title>Blog Energía Solar - Guías y Consejos | Nubia Solar</title>
        <meta name="description" content="Blog sobre energía solar, placas solares, subvenciones, consejos de instalación y ahorro energético en España." />
      </Helmet>

      <div className="min-h-screen">
        {/* Hero Section */}
        <section className="py-24 bg-nubia-gray-light">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <BookOpen className="w-16 h-16 text-nubia-gold-primary mx-auto mb-6" />
              <h1 className="text-5xl md:text-6xl font-bold text-nubia-green-primary mb-6">
                Blog Nubia Solar
              </h1>
              <p className="text-xl text-nubia-text-dark/70 leading-relaxed">
                Guías, consejos y actualidad sobre energía solar, instalación de placas solares y ahorro energético
              </p>
            </div>
          </div>
        </section>

        {/* Artículos */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-4">
            <div className="max-w-6xl mx-auto">
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                {articulos.map((articulo, index) => (
                  <Card key={index} className="nubia-shadow border-0 overflow-hidden group hover:shadow-2xl transition-all">
                    <div className="h-48 overflow-hidden">
                      <img 
                        src={articulo.imagen} 
                        alt={articulo.titulo}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                      />
                    </div>
                    <CardHeader>
                      <div className="text-sm text-nubia-gold-primary font-semibold mb-2">
                        {articulo.categoria}
                      </div>
                      <CardTitle className="text-xl text-nubia-green-primary leading-tight">
                        {articulo.titulo}
                      </CardTitle>
                      <div className="flex items-center gap-2 text-sm text-nubia-text-dark/60 mt-2">
                        <Calendar className="w-4 h-4" />
                        <span>{articulo.fecha}</span>
                      </div>
                    </CardHeader>
                    <CardContent>
                      <p className="text-nubia-text-dark/70 mb-4 leading-relaxed">
                        {articulo.extracto}
                      </p>
                      <Link to={`/blog/${articulo.slug}`}>
                        <Button variant="link" className="text-nubia-green-support hover:text-nubia-green-primary p-0 font-semibold">
                          Leer más <ArrowRight className="ml-2 w-4 h-4" />
                        </Button>
                      </Link>
                    </CardContent>
                  </Card>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-20 bg-nubia-gray-light">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-4xl font-bold text-nubia-green-primary mb-6">
              ¿Listo para Instalar Placas Solares?
            </h2>
            <p className="text-xl text-nubia-text-dark/70 mb-8 max-w-3xl mx-auto">
              Solicita tu estudio solar gratuito y descubre cuánto puedes ahorrar
            </p>
            <Link to="/contacto">
              <Button size="lg" className="bg-nubia-gold-primary hover:bg-nubia-gold-primary/90 text-nubia-green-primary font-semibold px-10 py-6">
                Solicitar Presupuesto Gratis
                <ArrowRight className="ml-2" />
              </Button>
            </Link>
          </div>
        </section>
      </div>
    </>
  );
};

export default Blog;
